const filter = document.querySelector(".Filter");

if (filter) {
  const shouldFilter =
    location.pathname === "/inspiration/" ||
    location.pathname === "/en/inspiration/";
  const inspirationGrid = document.querySelector(".Inspiration-grid");
  const randomIndex = Math.floor(Math.random() * (4 - 1 + 1) + 1);

  let isLoadingMore = false;
  let infiniteScrollUrl = "";
  let isMobile = window.innerWidth < 1024;

  /* Update inspiration grid icon */
  if (
    inspirationGrid &&
    location.pathname !== "/samples/" &&
    location.pathname !== "/en/samples/"
  ) {
    inspirationGrid.classList.add(`Inspiration-grid--${randomIndex}`);
    document
      .querySelector(`.Filter-gridIcon[data-grid-icon='${randomIndex}']`)
      .classList.add("--active");
  }

  /* Set inspiration in menu active if on inspire me page */
  if (location.pathname === "/inspirera-mig/") {
    const inspirationMenuItem = document.querySelectorAll(".Menu-item")[0];

    if (inspirationMenuItem) inspirationMenuItem.classList.add("--current");
  }

  /* Set inspiration in menu active if on inspire me page */
  if (location.pathname === "/inspirera-mig/") {
    const inspirationMenuItem = document.querySelectorAll(".Menu-item")[0];

    if (inspirationMenuItem) inspirationMenuItem.classList.add("--current");
  }

  const infiniteScrollListener = (url) => {
    const docEl = document.documentElement;

    const footerHeight = document
      .querySelector("footer")
      .getBoundingClientRect().height;
    const hasScrolledBottom =
      docEl.scrollHeight - docEl.scrollTop <= docEl.clientHeight + footerHeight;

    if (url && hasScrolledBottom && !isLoadingMore) {
      fetchAndLoadItems(url);
    }
  };
  let currentPage = 0;
  /* Fetches and appends new items into grid for infinite scroll */
  const fetchAndLoadItems = (url) => {
    const grid = document.querySelector(".Inspiration-grid");
    const loader = document.querySelector(".Inspiration-loader");

    isLoadingMore = true;
    loader.classList.add("--visible");
    grid.classList.add("--loading");

    fetch(url).then((res) => {
      try {
        currentPage++;
        res.text().then((result) => {
          const parser = new DOMParser();
          const newDocument = parser.parseFromString(result, "text/html");

          const newInspirationBlocks =
            newDocument.querySelectorAll(".Inspiration-block");

          newInspirationBlocks.forEach((item) => {
            grid.appendChild(item);
          });

          const nextLinkEl = newDocument.querySelector(".js-loadMore");

          if (nextLinkEl === null) {
            infiniteScrollUrl = "";
            window.removeEventListener("scroll", infiniteScrollListener);
          } else {
            infiniteScrollUrl = nextLinkEl.getAttribute("href");
          }

          loader.classList.remove("--visible");
          grid.classList.remove("--loading");

          if (location.pathname !== "/inspiration/") {
            window.history.pushState("", "", infiniteScrollUrl);
          }

          addZoomListeners();

          //Insert new sample blocks if no URL-params (No filter activated)
          const urlParams = document.location.search;

          console.log(urlParams);

          //Obs! This check wont work on start page, has to remake if it should show up there as well

          if (urlParams === "" || urlParams.includes("?load-more=")) {
            fetchAndAddSampleBlocks(newInspirationBlocks, currentPage);
            fetchAndAddGuideBlocks(newInspirationBlocks, currentPage);
          }
          //End sample blocks

          isLoadingMore = false;
        });
      } catch (error) {
        console.error(error);
      }
    });
  };

  /* Resizes width of search input */
  const resizeSearchInput = ({ target }) => {
    const defaultWidth = target.placeholder.length + 3;

    if (!target.value.length) {
      target.style.width = `${defaultWidth}ch`;
    } else if (target.value.length > defaultWidth) {
      target.style.width = `${defaultWidth + target.value.length}ch`;
    }
  };

  /* Fetches number of posts returned on each term button  */
  const fetchPostCount = (hrefs) => {
    const data = fetch(
      `${window.location.origin}/wp-json/atta45/v1/post-count`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ hrefs: hrefs }),
      }
    )
      .then((res) =>
        res.json().then((result) => {
          return result;
        })
      )
      .catch((err) => {
        console.log(err);
        return;
      });

    return data;
  };

  /* Disables term buttons if no posts are returned */
  const checkPostsReturned = (hrefs) => {
    const prevCount = document
      .querySelector(".Filter")
      .getAttribute("data-count");

    fetchPostCount(hrefs).then((data) => {
      document.querySelectorAll(".js-term").forEach((term, i) => {
        term.setAttribute("data-count", data[i]);
        if (
          (data[i] === 0 &&
            !location.search.includes(term.getAttribute("data-term"))) ||
          data[i] === prevCount
        ) {
          term.classList.add("--disabled");
        }
      });
    });
  };

  /* Term button interaction */
  const runTermButtonInteraction = (button) => {
    if (!button.classList.contains("--active")) {
      button.classList.add("--active");

      if (window.innerWidth < 764) {
        const numResults = getNumberOfResults(button.getAttribute("href"));
        console.log(numResults);
      }
    } else {
      button.classList.remove("--active");
    }
  };

  /* Tax button interaction */
  const runTaxButtonInteraction = (button) => {
    const buttonTaxName = button.getAttribute("data-taxonomy");
    if (!button.classList.contains("--open")) {
      const prevOpenBtn = document.querySelector(".js-taxonomy.--open");
      const prevOpenGroup = document.querySelector(".js-taxGroup.--open");
      if (prevOpenBtn) prevOpenBtn.classList.remove("--open");
      button.classList.add("--open");
      if (
        prevOpenGroup &&
        prevOpenGroup.getAttribute("data-taxonomy") !== buttonTaxName
      ) {
        prevOpenGroup.classList.remove("--open");
      }
      document.querySelectorAll(".js-taxGroup").forEach((group) => {
        if (
          group.getAttribute("data-taxonomy") ===
          button.getAttribute("data-taxonomy")
        ) {
          group.classList.toggle("--open");
        }
      });
    } else {
      button.classList.remove("--open");
      document
        .querySelector(`.Filter-group[data-taxonomy='${buttonTaxName}']`)
        .classList.remove("--open");
    }
  };

  /* Resets all filters */
  const resetFilterButtons = () => {
    document.body.classList.add("is-filtering");

    const openGroup = document.querySelector(".js-taxGroup.--open");
    const activeTaxButtons = document.querySelectorAll(".js-taxonomy.--active");
    const filterNumbers = document.querySelectorAll(".Filter-taxCount");
    const resetButton = document.querySelector(".Filter-button--reset");

    document
      .querySelectorAll(".js-term.--disabled")
      .forEach((btn) => btn.classList.remove("--disabled"));

    document.querySelector(".Filter-searchInput").value = "";

    if (resetButton) {
      resetButton.remove();
    }

    if (openGroup) {
      openGroup.classList.remove("--open");
    }

    if (activeTaxButtons.length) {
      activeTaxButtons.forEach((btn) => {
        btn.classList.remove("--open");
        btn.classList.remove("--active");
      });
    }

    if (filterNumbers.length) {
      for (let num of filterNumbers) {
        num.remove();
      }
    }
  };

  /* Sets active filter classes on load of page */
  const updateFilterButtons = (href) => {
    if (href === "./" || href === location.origin + location.pathname) {
      const taxCount = document.querySelector(".Filter-taxCount");
      if (taxCount) taxCount.remove();

      return;
    }

    // // Remove `order=rand` from href
    // const urlParams = new URLSearchParams(href.startsWith("?") ? href.slice(1) : href);
    // if (urlParams.has("order") && urlParams.get("order") === "rand") {
    //   urlParams.delete("order");
    // }

    // const updatedHref = urlParams.toString();
    // if (!updatedHref) return; // Stop if all parameters are removed

    // const activeFilters = updatedHref.split("&").map((filter) => filter.split("="));

    const activeFilters = href
      .substring(1)
      .split("&")
      .map((filter) => filter.split("="));

    activeFilters.forEach((filter) => {
      const taxonomy = filter[0];
      const terms = filter[1];

      const activeTaxButton = document.querySelector(
        `.Filter-button[data-taxonomy='${taxonomy}']`
      );

      if (activeTaxButton) {
        activeTaxButton.classList.add("--active");
        const taxCount = activeTaxButton.querySelector(".Filter-taxCount");

        if (!taxCount) {
          const number = document.createElement("span");
          number.classList.add("Filter-taxCount");
          number.innerHTML = ` ${terms.split(",").length}`;
          activeTaxButton.appendChild(number);
        } else {
          taxCount.innerText = ` ${terms.split(",").length}`;
        }
      }

      terms.split(",").forEach((term) => {
        document
          .querySelector(`.Filter-button--term[data-term='${term}']`)
          .classList.add("--active");
      });

      // console.log('terms');
      // console.log(terms);
    });
  };

  const closeFilterOnScroll = () => {
    let scrollTimer;
    let lastScrollTop = window.scrollY > 0 ? window.scrollY : 0;

    window.addEventListener(
      "scroll",
      () => {
        const openGroup = document.querySelector(".js-taxGroup.--open");
        const activeTaxButton = document.querySelector(".js-taxonomy.--open");

        window.clearTimeout(scrollTimer);

        scrollTimer = setTimeout(() => {
          lastScrollTop = window.scrollY;
        }, 100);

        if (
          openGroup &&
          activeTaxButton &&
          window.scrollY > lastScrollTop + 200
        ) {
          openGroup.classList.remove("--open");
          activeTaxButton.classList.remove("--open");
        }
      },
      false
    );
  };

  const runFiltering = (e) => {
    // Todo
    /* 
        När filter knappen trycks hämtas promise för både ny DOM och filter count. 
        Sätt alla filterknappar disabled och starta loader efter items fade out
        Promse.all(promises) => {
            1. By ut dom
            2. Fade in av items
            3. Uppdatera filter knappar (count) 
        }
     */

    const base = location.origin + location.pathname;
    const prevOpenGroup = document.querySelector(".js-taxonomy.--open");
    let url = e.target.getAttribute("href");

    if (!shouldFilter) return;
    if (!url) return;
    if (url === "./") url = base;

    e.preventDefault();

    /* Perceived performance only */
    updateFilterButtons(url);
    window.history.pushState("", "", url);
    document.body.classList.add("is-filtering");

    fetch(url, {
      method: "GET",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then((res) => {
      try {
        res.text().then((result) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(result, "text/html");
          const newGrid = doc.querySelector(".Inspiration-grid");
          const oldGrid = document.querySelector(".Inspiration-grid");
          const newFilter = doc.querySelector(".Filter");
          const loadMoreButton = document.querySelector(
            ".js-loadMore:not(--hidden)"
          );
          const newLoadMoreButton = doc.querySelector(".js-loadMore");
          const zoomImageEls = doc.querySelector(".js-imageZoom");

          if (loadMoreButton) {
            if (newLoadMoreButton) {
              loadMoreButton.setAttribute(
                "href",
                newLoadMoreButton.getAttribute("href")
              );
              loadMoreButton.classList.remove("--hidden");
            } else {
              loadMoreButton.classList.add("--hidden");
            }
          }

          // if (window.innerWidth < 764) {
          //     fetchPostCount(url).then((result) => {
          //         console.log(result);
          //         // document.querySelector(".js-filterResultsCount").innerHTML = ``
          //     });
          // }

          const oldFilter = document.querySelector(".Filter");

          const newTerms = doc.querySelectorAll(".js-term");
          const newHrefs = [...newTerms].map((term) =>
            term.getAttribute("href")
          );

          /* Reset classes to new filter */
          newFilter
            .querySelector(
              `.js-taxonomy[data-taxonomy='${prevOpenGroup.getAttribute(
                "data-taxonomy"
              )}']`
            )
            .classList.add("--open");
          newFilter
            .querySelector(
              `.js-taxGroup[data-taxonomy='${prevOpenGroup.getAttribute(
                "data-taxonomy"
              )}']`
            )
            .classList.add("--open");

          /* If all filters are unset we need to manually activate disabled filters */
          if (url === base) {
            doc
              .querySelectorAll(".js-term.--disabled")
              .forEach((term) => term.classList.remove("--disabled"));
          }

          /* Index for new grid layout + grid icon */
          const randomIndex = Math.floor(Math.random() * (4 - 1 + 1) + 1);

          doc
            .querySelector(`.Filter-gridIcon[data-grid-icon='${randomIndex}']`)
            .classList.add("--active");

          const newSearchInput = doc.querySelector(".Filter-searchInput");
          const searchInputWidth = `${newSearchInput.placeholder.length + 3}ch`;
          doc.querySelector(".Filter-searchInput").style.width =
            searchInputWidth;

          oldGrid.classList.add("--hidden");
          newGrid.classList.add(`Inspiration-grid--${randomIndex}`, "--hidden");

          checkPostsReturned(newHrefs);

          /* Timeout to create opacity animation effect */
          setTimeout(() => {
            oldGrid.remove();
            oldFilter.after(newGrid);
            newGrid.before(newFilter);
            oldFilter.remove();
            updateFilterButtons(url);
            const zoomEvent = new Event("addImageZoom");
            window.dispatchEvent(zoomEvent);
          }, 150);

          setTimeout(() => {
            newGrid.classList.remove("--hidden");
            if (isMobile) document.body.classList.remove("--no-scroll");
          }, 300);

          /* Update filter */
          if (window.scrollY != 0) {
            window.scroll(0, 0);
            // window.scrollTo({
            //     top: 0,
            //     left: 0,
            //     behavior: "smooth",
            // });
          }

          document.body.classList.remove("is-filtering");
        });
      } catch (error) {
        console.error(error);
        location.assign("/inspiration");
      }
    });
  };

  let subMenuCurrentWrapperIndex = -1;
  const addClickEventListeners = (e) => {
    /* Term button */
    if (e.target.classList.contains("js-term")) {
      document.body.classList.remove("--filter-open");
      infiniteScrollUrl = ""; // disables infinite scroll

      runTermButtonInteraction(e.target);
      runFiltering(e);
      updateFilterButtons(e.target.getAttribute("href"));
    }

    /* Tax button */
    if (e.target.classList.contains("js-taxonomy")) {
      runTaxButtonInteraction(e.target);
    }

    /* Reset filter */
    if (e.target.classList.contains("Filter-button--reset")) {
      resetFilterButtons();
    }

    /* Add grid loader for inspire me button */
    if (e.target.classList.contains("js-inspireButton")) {
      document.body.classList.add("is-filtering");
    }

    /* Close filter if clicked outside and filter is open */
    if (
      !e.target.classList.contains("Filter-button") &&
      !e.target.classList.contains("Filter-button--term") &&
      !e.target.classList.contains("Filter-button--reset") &&
      !e.target.classList.contains("Filter-group") &&
      !document.body.classList.contains("is-loading")
    ) {
      const openGroup = document.querySelector(".js-taxGroup.--open");
      const activeButton = document.querySelector(".js-taxonomy.--open");

      if (openGroup && activeButton) {
        openGroup.classList.remove("--open");
        activeButton.classList.remove("--open");
      }
    }

    /* Open filter in mobile */
    if (e.target.classList.contains("Filter-openButton")) {
      document.querySelector(".Filter").classList.toggle("--mobileOpen");
      document.body.classList.toggle("--filter-open");
      document.body.classList.add("--no-scroll");
      e.target.classList.toggle("--open");
    }

    /* Load more button */
    if (e.target.classList.contains("js-loadMore")) {
      e.preventDefault();

      const url = e.target.getAttribute("href");
      fetchAndLoadItems(url);

      e.target.classList.add("--hidden");

      window.addEventListener("scroll", () => {
        if (infiniteScrollUrl) {
          infiniteScrollListener(infiniteScrollUrl);
        }
      });
    }

    /* Open filter sub menu in mobile */
    if (e.target.classList.contains("js-filter-show-mobile")) {
      const submenu = document.querySelector(".js-filter-mobile-submenu");
      if (subMenuCurrentWrapperIndex === 0) {
        subMenuCurrentWrapperIndex = -1;
        submenu.classList.add("--hidden");
      } else {
        subMenuCurrentWrapperIndex = 0;
        submenu.classList.remove("--hidden");
      }
      document
        .querySelector(".js-filter-mobile-show-wrapper")
        .classList.remove("--hidden");
      document
        .querySelector(".js-filter-mobile-sort-wrapper")
        .classList.add("--hidden");
    }

    if (e.target.classList.contains("js-filter-sort-mobile")) {
      const submenu = document.querySelector(".js-filter-mobile-submenu");
      if (subMenuCurrentWrapperIndex === 1) {
        subMenuCurrentWrapperIndex = -1;
        submenu.classList.add("--hidden");
      } else {
        subMenuCurrentWrapperIndex = 1;
        submenu.classList.remove("--hidden");
      }
      document
        .querySelector(".js-filter-mobile-show-wrapper")
        .classList.add("--hidden");
      document
        .querySelector(".js-filter-mobile-sort-wrapper")
        .classList.remove("--hidden");
    }
  };

  /****** INITIATIONS *****/

  window.addEventListener("load", () => {
    const hrefs = [...document.querySelectorAll(".js-term")].map((term) =>
      term.getAttribute("href")
    );

    document.querySelector(".js-search").addEventListener("submit", () => {
      document.body.classList.add("is-filtering");
    });

    // document.querySelector(".Filter-searchInput").addEventListener("input", (e) => {
    //     resizeSearchInput(e);
    // });

    if (window.innerWidth > 1024) closeFilterOnScroll();
    if (shouldFilter) checkPostsReturned(hrefs);
    if (location.search && shouldFilter) updateFilterButtons(location.search);

    window.addEventListener("click", addClickEventListeners);
  });
}
